module.exports = __webpack_public_path__ + "img/screen-participants-dark-en.bc35e776.png";